import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import {
    onlyUnique, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function DataFilter({
    setCurrentPage, 
    setFilter, 
    curFilter, 
    defaultFilter, 
    items,
    dataFrame,
    width,
    minWidth, 
}){
    const [showFilter, setShowFilterForm] = useState(false);
    return (
        <>
        <button
            type = "button"
            className = "headerButton"
            style = {{
                backgroundColor: 
                Object.entries(curFilter).some(([key, value]) => defaultFilter[key] !== value)?
                "rgb(0,123,255)"
                :undefined
            }} 
            onClick = {() => {setShowFilterForm(true)}}
        >
            Filter
        </button>
        {showFilter?
        <Modal
            touchOutsideClose = {true}
            closeIt = {() => setShowFilterForm(false)}
            title = "Filter"
            width = {width}
            minWidth = {minWidth}
        >
            <div className = "mt-3 mb-3">
                <button type = "button" className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</button>
            </div>
            {dataFrame.map((item, itemIndex) => 
            item.type === "select"?
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
               <label className = "font-weight-bold text-nowrap" htmlFor = {item.key}>{item.label}:</label>
                <select
                    id = {item.key}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key]}
                    onChange = {e => {
                    setFilter({...curFilter, [item.key]: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    {item.options.map((opt, optIndex) => <option key = {optIndex} value = {opt.value}>{opt.label}</option>)}
                </select>
                {
                curFilter[item.key] !== defaultFilter[item.key]?
                <button type = "button" className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key]: defaultFilter[item.key]})}}>❌</button>:
                null
                }
            </div>
            :item.type === "date"?
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <span className = "font-weight-bold text-nowrap">{item.label}:</span>
                <label htmlFor = {item.key + "Min"} className = "mb-0 ml-3">after:</label>
                <input
                    id = {item.key + "Min"}
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter[item.key + "Max"] || "2999-12-31"}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key + "Min"] ?? ""}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key + "Min"]: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label htmlFor = {item.key + "Max"} className = "mb-0 ml-3">before:</label>
                <input
                    id = {item.key + "Max"}
                    type = "date"
                    min = {curFilter[item.key + "Min"] || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key + "Max"] ?? ""}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key + "Max"]: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter[item.key + "Max"] || curFilter[item.key + "Min"]?
                <button className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key + "Min"]: defaultFilter[item.key + "Min"], [item.key + "Max"]: defaultFilter[item.key + "Max"]})}}>❌</button>:
                null
                }
            </div>
            :item.type === "number"?
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <span className = "font-weight-bold text-nowrap">{item.label}:</span>
                <label htmlFor = {item.key + "Min"} className = "mb-0 ml-3">min:</label>
                <input
                    id = {item.key + "Min"}
                    type = "number"
                    min = "1900-01-01"
                    max = {curFilter[item.key + "Max"] || "2999-12-31"}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key + "Min"] ?? ""}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key + "Min"]: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label htmlFor = {item.key + "Max"} className = "mb-0 ml-3">max:</label>
                <input
                    id = {item.key + "Max"}
                    type = "number"
                    min = {curFilter[item.key + "Min"] || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key + "Max"] ?? ""}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key + "Max"]: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter[item.key + "Max"] || curFilter[item.key + "Min"]?
                <button className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key + "Min"]: defaultFilter[item.key + "Min"], [item.key + "Max"]: defaultFilter[item.key + "Max"]})}}>❌</button>:
                null
                }
            </div>
            :<div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <label className = "font-weight-bold text-nowrap" htmlFor = {item.key}>{item.label}:</label>
                <input
                    id = {item.key}
                    list = {item.key + " list"}
                    type = "text"
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key]}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key]: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                    autoComplete = {item.autoComplete ?? "off"}
                />
                {!item.noList?
                <datalist id = {item.key + " list"} value = {curFilter[item.key]}>
                    {items.map(itemObj => itemObj[item.key]).filter(onlyUnique).map((itemContent, itemContentIndex) => <option key = {itemContentIndex}>{itemContent}</option>)}
                    {item.extraData?.map((itemContent, itemContentIndex) => <option key = {itemContentIndex}>{itemContent}</option>)}
                </datalist>
                :<></>}
                {curFilter[item.key] !== defaultFilter[item.key]?
                <button type = "button" className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key]: defaultFilter[item.key]})}}>❌</button>:
                null
                }
            </div>)}
            <div className = "mt-3 mb-3">
                <button type = "button" className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</button>
            </div>
        </Modal>
        :null}
        </>
    )
}